/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { saveScoreOrder } from '../../../../../../app/page/page-storage/kpi/kpi.actions';
import { kpiPageSelectors } from '../../../../../../app/page/page-storage/kpi/kpi.selectors';
import { useSelect } from '../../../../../../utils/selector.utils';
import { SortableScoreList } from './SortableScoreList';
import { IWidgetKpiSettingsProps } from './types';
import { SortableGroupedByUserScoreList } from './SortableGroupedByUserScoreList';

export const WidgetKpiSettings: FunctionComponent<IWidgetKpiSettingsProps> = ({
  filterId,
  onScoreSelection,
  selectedScoreIds = [],
  kpisGroupedByUser = false,
  userIds = [],
}) => {
  const kpiRowIds = useSelect(kpiPageSelectors.selectKpiRowIds);
  const [rows, setRows] = useState<string[]>(kpiRowIds);
  const dispatch = useDispatch();

  useEffect(() => {
    setRows(kpiRowIds);
  }, [kpiRowIds]);

  const handleReorder = useCallback(
    (newOrder: string[]) => {
      setRows(newOrder);
      dispatch(saveScoreOrder(newOrder));
    },
    [dispatch],
  );

  return (
    <div className="panel">
      <div className="panel-body pt-0 ho-hover" style={{ height: '100vh' }}>
        <div className="border-radius-1 lightGray-bg p-2" style={{ position: 'sticky', top: '20px' }}>
          <div className="row">
            <div className="col">
              <div className="table-container kpi-settings-table" role="table" aria-label="KPIs settings">
                <div className="flex-table header panel mb-1 aic py-0" role="rowgroup">
                  <div className="flex-row" role="columnheader" style={{ width: '5%' }}></div>
                  <div className="flex-row" role="columnheader">
                    USER
                  </div>
                  <div className="flex-row" role="columnheader">
                    MEASURABLE
                  </div>
                  <div className="flex-row" role="columnheader">
                    GOAL
                  </div>
                  <div className="flex-row last" role="columnheader" />
                </div>
                {kpisGroupedByUser ? (
                  <SortableGroupedByUserScoreList
                    kpiRowIds={rows}
                    filterId={filterId}
                    onScoreSelection={onScoreSelection}
                    selectedScoreIds={selectedScoreIds}
                    onReorder={handleReorder}
                  />
                ) : (
                  <SortableScoreList
                    rows={rows}
                    filterId={filterId}
                    onScoreSelection={onScoreSelection}
                    selectedScoreIds={selectedScoreIds}
                    onReorder={handleReorder}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
